module.exports = __webpack_public_path__ + "img/client_registry_default.0ed8d1c3.png";